import useBulkSender, { BulkSender } from "@/hooks/useBulkSender";
import { createContext, PropsWithChildren, useContext } from "react";

const GeneralContext = createContext<{
    bulkSender: {
        bulkSenders: Map<string, BulkSender>,
        onHandleBulkSender: (
            contacts: string[],
            channel: string | 'unofficial_personal_wpp',
            message: BulkSender['message']
        ) => void
    }
}>({
    bulkSender: {
        bulkSenders: new Map(),
        onHandleBulkSender: () => { }
    }
});

export function GeneralContextProvider({ children }: PropsWithChildren) {
    const bulkSenderData = useBulkSender();
    return <GeneralContext.Provider value={{ bulkSender: bulkSenderData }}>
        {children}
    </GeneralContext.Provider>
}

export const useGeneralContext = () => useContext(GeneralContext);
export default GeneralContext;